import service from './request'

/**
 * 获取客户等级列表
 */
 export const cusLevelGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/cusLevel/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加客户等级信息
 */
 export const cusLevelAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusLevel/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改客户等级信息
 */
 export const cusLevelUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusLevel/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除客户等级信息
 */
 export const cusLevelDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusLevel/delInfo',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/cusLevelManagement.js